import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Cookies from "js-cookie";
import { Row, Col } from "reactstrap";
import { withTranslation, useTranslation } from "react-i18next";


import ShowOffField, { ShowOffFieldContainer } from "./ShowOffField";
import { hasPhotoVoted, userIsLogin } from "./Components/VoteWithoutAuth/VoteWithoutAuth";
import { getAuthorNameOfPhoto } from "./helpers";
import { VoteWithoutAuthModal } from "./VoteWithoutAuthModal/VoteWithoutAuthModal";
import { width } from "styled-system";

function chunkifyPhotos(photos, chunks) {
  const initialArray = new Array(chunks).fill(null).map(() => []);
  let watchman = -1;
  return photos.reduce((sum, curr) => {
    watchman += 1;
    if (watchman >= chunks) {
      watchman = 0;
    }
    sum[watchman].push(curr);
    return sum;
  }, initialArray);
}

const RelatedGallery = ({
  photos,
  onClick,
  voteOnRelatedPhoto,
  onRemove,
  uploadComponent,
  isEditMode,
  onEdit,
  md,
  chunks,
}) => {
  const { t } = useTranslation(["widgets"]);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const userLoggedIn = userIsLogin();

  useEffect(() => {
    if (showLogin) {
      document.querySelector("body").style.overflowY = "hidden";
    } else {
      document.querySelector("body").style.overflowY = "scroll";
    }
  }, [showLogin]);

  const chunkedPhotos = chunkifyPhotos(photos, chunks);

  return (
    <>
      <ShowOffFieldContainer>
        <Row>
          {chunkedPhotos.map((photos, k) => (
            <Col key={k} sm={12} md={md}>
              <>
                {k === 0 && uploadComponent}
                {!!photos === true && photos.map((photo, index) => (
                  <ShowOffField
                    photo={photo}
                    index={index}
                    key={photo.id}
                    onClick={() => onClick(photo)}
                    description={photo.title}
                    tags={photo.tags}
                    imageUrl={photo.image_thumbnail || photo.image}
                    starsCount={photo.votes_count}
                    author={getAuthorNameOfPhoto(photo)}
                    isLiked={hasPhotoVoted(photo, userLoggedIn)}
                    onVote={voteOnRelatedPhoto}
                    isRewarded={photo.rewards.length > 0}
                    isReadOnly={!userLoggedIn}
                    authorSlug={photo.owner.slug}
                    isEditMode={isEditMode}
                    isDraft={photo.publish_status === 1}
                    isRejected={photo.publish_status === 3}
                    onRemove={() => onRemove(photo)}
                    onEdit={() => onEdit(photo)}
                  />
                ))}
              </>
            </Col>
          ))}
          {
            !!photos.length === false &&
            <div className="text-center" style={{margin: "0 auto"}}>
              <p>{t("widgets:gallery.noRelatedPhotos")}</p>
            </div>
          }
        </Row>
      </ShowOffFieldContainer>
    </>
  );
};

RelatedGallery.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClick: PropTypes.func.isRequired,
  onVoteClick: PropTypes.func.isRequired,
  uploadComponent: PropTypes.element,
  isEditMode: PropTypes.bool,
  onRemove: PropTypes.func,
  md: PropTypes.number,
  chunks: PropTypes.arrayOf(PropTypes.array),
};
RelatedGallery.defaultProps = {
  uploadComponent: null,
  isEditMode: false,
  md: 4,
  chunks: 3,
  onRemove: () => {},
};

export default withTranslation(["widgets"])(RelatedGallery);
